import image1 from "./newl.png";
import image2 from "./newl.png";

const stoneimage = [image1, image2];

export default stoneimage;
